import { render, staticRenderFns } from "./Calculators.vue?vue&type=template&id=0086aece&scoped=true&"
import script from "./Calculators.vue?vue&type=script&lang=js&"
export * from "./Calculators.vue?vue&type=script&lang=js&"
import style0 from "./Calculators.vue?vue&type=style&index=0&id=0086aece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0086aece",
  null
  
)

export default component.exports